import { ITrendFilters } from '@mg-platform/reports/reports-data-access'
import { IEnterpriseTrendResponse } from '../../interfaces/enterprise-trends.interface'

export interface EnterpriseTrendsStateModel {
  trends: IEnterpriseTrendResponse
  trendFilters: ITrendFilters
}
